import { render, staticRenderFns } from "./PageTeaser.vue?vue&type=template&id=410a4051&scoped=true&"
import script from "./PageTeaser.vue?vue&type=script&lang=ts&"
export * from "./PageTeaser.vue?vue&type=script&lang=ts&"
import style0 from "./PageTeaser.vue?vue&type=style&index=0&id=410a4051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a4051",
  null
  
)

export default component.exports